export const CrudAction = {
	Create: 'create',
	Read: 'read',
	Update: 'update',
	Delete: 'delete',
} as const;

export type CrudActionCreate = typeof CrudAction.Create;
export type CrudActionRead = typeof CrudAction.Read;
export type CrudActionUpdate = typeof CrudAction.Update;
export type CrudActionDelete = typeof CrudAction.Delete;
export type CrudActionWrite = CrudActionCreate | CrudActionUpdate;
